import { LoadingOutlined } from '@ant-design/icons';
import { Spin } from 'antd';
import classNames from 'classnames';
import styles from './_suspenseLoading.module.scss';

interface Props {
  readonly darkMode?: boolean;
}

export function SuspenseLoading(props: Props) {
  const { darkMode } = props;

  return (
    <div className={classNames(styles.container, { [styles.darkMode]: darkMode })}>
      <Spin indicator={<LoadingOutlined style={{ fontSize: 32 }} spin />} />
    </div>
  );
}
